import {parseQueryParams, getQueryString, getLangFromUrlPathname} from 'mad-utils/lib/react';

interface CanvasQuery {
    email?: string;
    clinicEntryId?: string;
    canvasConfirmationCode?: string;
}

export const checkCanvasAuthQuery = () => {
    const qs = parseQueryParams<CanvasQuery>(window.location.search);
    const redirectLogin = `/auth/${getLangFromUrlPathname()}/login`;
    if (!qs || !qs.email || !qs.clinicEntryId) {
        window.location.href = `${redirectLogin}?${getQueryString()}`;
    }
    return qs || {};
};

export const checkRedirectToCanvasAuth = (redirect = true, route = 'flu-vaccine-safety-survey') => {
    const qs = parseQueryParams<CanvasQuery>(window.location.search);
    const redirectCanvas = `/auth/${getLangFromUrlPathname()}/${route}`;
    if (qs && qs.email && qs.clinicEntryId) {
        if (redirect === false) return `${redirectCanvas}?${getQueryString()}`;
        window.location.href = `${redirectCanvas}?${getQueryString()}`;
    }
};
